module.exports = __webpack_public_path__ + "img/des-main-background-640.4c6de4b8.jpeg";